<uni-nav-new-item-container
    [labelKey]="labelKey"
    [iconName]="expandItem.iconName"
    [isExpanded]="isGroupExpanded"
    [toggleType]="toggleType"
    (toggle)="onToggleGroup()"
>
</uni-nav-new-item-container>
